// Canonical taxYear format for calc-profile API calls is "FY{year}" (matches
// PartnershipContext's default and BackEnd's CalcProfileService.NormalizeTaxYear).
// Strips any non-digit characters so "2024", "FY2024", "fy2024" all resolve to the
// same profile instead of the BackEnd creating a second CalcProfile row per format.
export const normalizeTaxYear = (taxYear: string | number): string => {
  const digits =
    typeof taxYear === 'number' ? String(taxYear) : taxYear.replace(/\D/g, '');
  if (!digits) {
    throw new Error(`Invalid taxYear format: ${taxYear}`);
  }
  return `FY${digits}`;
};
